/**
 *
 * Actions Service Constants
 *
 */

import { SERVICE_NAMESPACE } from 'common';

export const URL = (apiUrl, transferId, action) => `${apiUrl}/evaluated_transfers/${transferId}/${action}`;

export const NAMESPACE = `${SERVICE_NAMESPACE}/actions`;

// Trigger a fetch request in sagas
export const ACTIONS_REQUEST = `${NAMESPACE}/ACTIONS_REQUEST`;

// Current status of the service
export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;
export const LOADING = `${NAMESPACE}/LOADING`;
export const SUCCESS = `${NAMESPACE}/SUCCESS`;
export const FAILURE = `${NAMESPACE}/FAILURE`;

export const ActionType = Object.freeze({
  Approve: 'actions/approve',
  Reject: 'reject',
  Reopen: 'resurrect',
  UpdateAmount: 'updateAmount',
  Create: 'actions/create',
  HasReturn: 'return',
  Cancel: 'cancel',
});



// WEBPACK FOOTER //
// ./src/services/actions/constants.js